import React from 'react';

import { TextField } from '@mui/material';

export const FiltradorInput = ({ setSearchTerm, searchTerm, sx, labelText = 'Filtrar por nombre' }) => {
  const handleSearchTerm = (event) => {
    setSearchTerm(event.target.value);
  };

  return <TextField onChange={handleSearchTerm} label={labelText} value={searchTerm} sx={sx} size="medium" />;
};
